import type { Model } from '@patsnap/tahiti-core/common/model';
import type { ShareAuthCheckData, DuplicateModuleData } from '../types';

export interface DuplicateService extends Model<DuplicateModuleData> {
    createShareTask(data: ShareAuthCheckData): Promise<string>;
    executeShareTask(data: ShareAuthCheckData): void;
    fetchData(data: ShareAuthCheckData): Promise<void>;
    openUrl(url: string): void;
}

export const DuplicateService = Symbol('DuplicateService');
